import { Component } from 'vue';
import WidgetDocumentsAccountStatement from '@/widgets/documents/account-statement';
export enum DOCUMENT_TAB {
  STATEMENTS = 'statements',
}
export enum FILE_ACTION_TYPE {
  SHARE = 'SHARE',
  DOWNLOAD = 'DOWNLOAD',
}
export interface Icon {
  id: FILE_ACTION_TYPE;
  icon: Component;
  tooltip: string;
}

export interface Tab {
  to: DOCUMENT_TAB;
  component: Component;
  tabNav: string;
}

export interface DocumentFile {
  title: string;
  iconsShow: boolean;
  icons?: Icon[];
}

export const INITIAL_TABS = [
  {
    to: DOCUMENT_TAB.STATEMENTS,
    component: WidgetDocumentsAccountStatement,
    tabNav: 'DOCUMENTS.STATEMENT_ACCOUNT.NAV',
  },
];
